import { driver } from 'driver.js';
import '../main.css';
import 'driver.js/dist/driver.css';
import { setActiveTab } from '@/redux/reducers/inventoryReducer';

export const reportsDriverObj = (dispatch) => {
  const driverObj = driver({
    showProgress: true,
    nextBtnText: 'Next',
    prevBtnText: 'Previous',
    doneBtnText: 'Done',
    popoverClass: 'driverjs-theme',
    steps: [
      {
        element: '.generateReports',
        popover: {
          title: 'Generate Reports',
          description:
            'This section allows you to generate reports for inventory, transactions and orders. ' +
            'For detailed information on how to generate reports, please click the instructions button.',
          side: 'left',
          align: 'start',
        },
      },
      {
        element: '.reportFilters',
        popover: {
          title: 'Report Filters',
          description: 'This section shows the filters for the selected card in the above section.',
          side: 'left',
          align: 'start',
          onNextClick: () => {
            dispatch(setActiveTab('4'));
            driverObj.moveNext();
          },
        },
      },
      {
        element: '.addToReport',
        popover: {
          title: 'Add to Report',
          description: 'Click here to add the filtered data to the report.',
          side: 'left',
          align: 'start',
        },
      },
      {
        element: '.removeFromReport',
        popover: {
          title: 'Remove from Report',
          description: 'Click here to remove the filtered data from the report.',
          side: 'left',
          align: 'start',
        },
      },
      {
        element: '.exportReport',
        popover: {
          title: 'Export Report',
          description:
            'Click here to export the report in an Excel file. The Excel file will only include ' +
            'the added report sections.',
          side: 'left',
          align: 'start',
        },
      },
      {
        element: '.reportTable',
        popover: {
          title: 'Report Table',
          description: 'This section shows the table for the selected card in the above section.',
          side: 'left',
          align: 'start',
        },
      },
    ],
  });
  return driverObj;
};

export default reportsDriverObj;
